/* Disappearing-messages options shared by every screen that sets or shows the timer.
 * `days` is the value the server stores; the server and mobile apps accept only these. */
export const DISAPPEAR_OPTIONS = [
    { id: 'Off', days: 0, labelKey: 'chat.detail.OFF', hintKey: 'chat.detail.DISAPPEAR_OFF_HINT' },
    {
        id: '24hours',
        days: 1,
        labelKey: 'chat.detail.DISAPPEAR_24_HOURS',
        hintKey: 'chat.detail.DISAPPEAR_24_HOURS_HINT',
    },
    { id: '7days', days: 7, labelKey: 'chat.detail.DISAPPEAR_7_DAYS', hintKey: 'chat.detail.DISAPPEAR_7_DAYS_HINT' },
    {
        id: '90days',
        days: 90,
        labelKey: 'chat.detail.DISAPPEAR_90_DAYS',
        hintKey: 'chat.detail.DISAPPEAR_90_DAYS_HINT',
    },
];

const OFF_OPTION = DISAPPEAR_OPTIONS[0];

const optionById = id => DISAPPEAR_OPTIONS.find(option => option.id === id) || OFF_OPTION;

/**
 * Server value (days) of an option; unknown options turn the timer off.
 *
 * @param {string} id One of 'Off', '24hours', '7days' or '90days'.
 * @returns {number} 0, 1, 7 or 90.
 */
export const optionToMsgDisappear = id => optionById(id).days;

/**
 * Option of a server value; the server may send the days as a string.
 *
 * @param {number|string} value Days stored by the server.
 * @returns {string} The option id; unknown values read as 'Off'.
 */
export const msgDisappearToOption = value =>
    (DISAPPEAR_OPTIONS.find(option => option.days === Number(value)) || OFF_OPTION).id;

/**
 * i18n key of an option's label, shared by the pop-ups and the info rows.
 *
 * @param {string} id One of 'Off', '24hours', '7days' or '90days'.
 * @returns {string} The locale key; unknown values read as Off.
 */
export const getDisappearOptionLabelKey = id => optionById(id).labelKey;
